import { actions } from './AppReducer';

export function attemptSetActiveRoute(data) {
  return { type: actions.SET_ROUTE, payload: { data } };
}

export function attemptSetLanguage(data) {
    return { type: actions.SET_LANGUAGE, payload: { data } };
}

export function attemptToggleUserblock() {
  return { type: actions.TOGGLE_USER_BLOCK };
}

export function addLoadingMessage(data) {
    return { type: actions.ADD_LOADING_MESSAGE, payload: { data } };
}

export function removeLoadingMessage(data) {
    return { type: actions.REMOVE_LOADING_MESSAGE, payload: { data } };
}

